import * as Scrivito from "scrivito";

const attributeValues = [
  "enum",
  {
    values: [
      "empty",
      "deadline",
      "credits",
      "start",
      "location",
      "lang",
      "degree",
      "form",
      "orientation",
      "courseWorkload",
      "tuitionFee",
    ],
  },
];
const CourseDetailsWidget = Scrivito.provideWidgetClass("CourseDetailsWidget", {
  attributes: {
    course: ["reference", { only: ["CoursePage"] }],
    value1: attributeValues,
    value2: attributeValues,
    value3: attributeValues,
    value4: attributeValues,
    value5: attributeValues,
    value6: attributeValues,
    value7: attributeValues,
    value8: attributeValues,
    value9: attributeValues,
    value10: attributeValues,
  },
});

export default CourseDetailsWidget;
